<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3">
<p class="auth">For my wife Brittany.</p>
<p class="auth1">Thanks for your continued support in all that I do.</p>
</a><a id="VPS-4">
<div class="img_container">
<img alt="image" src="images/4.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Author.vue?985fff28